import type { FC } from "react";

import type { ProductGalleryAsset } from "@jti/fe-common";
import { getOptimizedMagentoImageUrl } from "@jti/ui/utils/getOptimizedMagentoImageUrl";

// Based on &__thumbnailImg styles from styles.scss
const THUMBNAIL_SIZE = 55;
const THUMBNAIL_QUALITY = 80;

const getOptimizedThumbnailUrl = (url: string, size: number) =>
  getOptimizedMagentoImageUrl({
    url,
    width: size,
    height: size,
    quality: THUMBNAIL_QUALITY,
  });

export const ProductGalleryThumbnailImage: FC<{ item: ProductGalleryAsset; idx?: number }> = ({ item, idx = 0 }) => {
  const thumbnailUrl = (item.type === "video" && item.previewPath) || item.path;

  if (!thumbnailUrl) {
    return null;
  }

  // Keep thumbnails visually identical while avoiding full-size image downloads
  // for carousel navigation and high-density screens.
  const optimizedThumbnail1x = getOptimizedThumbnailUrl(thumbnailUrl, THUMBNAIL_SIZE);
  const optimizedThumbnail2x = getOptimizedThumbnailUrl(thumbnailUrl, THUMBNAIL_SIZE * 2);

  return (
    <img
      src={optimizedThumbnail1x}
      srcSet={`${optimizedThumbnail1x} 1x, ${optimizedThumbnail2x} 2x`}
      alt={item.label ?? ""}
      className="carousel__thumbnailImg"
      data-testid={`carousel__thumbnail-${idx}`}
      loading="lazy"
      decoding="async"
      width={THUMBNAIL_SIZE}
      height={THUMBNAIL_SIZE}
    />
  );
};
